module.exports = __webpack_public_path__ + "static/media/box.ac70953f.svg";